<template>
  <div>
    <ul class="flex flex-wrap rounded grid  lg:grid-cols-4 gap-2 ">
      <li v-for="todolist in todolists" :key="todolist.id">
        <router-link :to="{ name: 'TodolistDetails', params: { id: todolist.id } }">
          <figure class="md:flex rounded-xl bg-gray-800  md:p-0">
            <div class=" p-3 text-center md:text-left">
              <h3 class="text-cyan-600 text-lg">{{ todolist.title }}</h3>
              <p class="mt-3 text-gray-400 ">{{ todolist.checklists.length }} todolist</p>
              <p class="text-gray-400 text-sm">created by Mr / Ms {{ todolist.userName }}</p>
            </div>
          </figure>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["todolists"],
}
</script>
